import InstitutionAutoComplete from './InstitutionAutoComplete';

export default InstitutionAutoComplete;
